<template>
 <div v-if="showModal">
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-body">
            <div class="image-details row">
              <div class="col-12">
                <p>
                  <strong>Welcome to our Digital Asset Library.</strong>
                </p>
                <p>By entering this site you agree to digital asset usage <a href="https://www.rhinorack.com/dam-terms-and-conditions-of-access-and-use" target="_blank">terms and conditions.</a></p>
                <p><input type="checkbox" v-model="terms"> I agree.</p>
              </div>
              <div class="col-md-12">
                  <button class="btn btn-hover btn-primary btn-block" :disabled="!terms" @click="acceptTermsAndConditions()"  style="width: 100%; margin-top:2rem;">Enter now</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</div>
</template>
<script>
  export default {
    data() {
      return {
        terms: false,
        clicked: false,
        showModal:true
      }
    },
    beforeMount() {
      if(document.cookie.indexOf('dam_terms_and_conditions=accepted') > -1){
        this.showModal = false;
      }
    },
    methods: {
      acceptTermsAndConditions() {
        document.cookie ="dam_terms_and_conditions=accepted";
        this.hideModal();
      },
      hideModal() {
        this.showModal = false;
      }
    },
  }
</script>
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 800px;
  margin: 0px auto;
  padding: 20px 30px;
  border-radius: 2px;
  transition: all 0.3s ease;
  font-family: "trim-light"
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  display: flex;
  flex-direction: column;
}

.image-details {
  display: flex;
  text-transform: capitalize;
  justify-content: space-between;
  background-color: #ffffff;
  padding: 25px;
  line-height: 1.8;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.modal-button {
  width: 100px;
  height: 50px;
  background-color: #B65A02;
  border: none;
  color: white;
  cursor: pointer;
  align-items: center;
  outline: none;
}

.modal-url {
  white-space: nowrap;
  width: 500px;
  text-overflow: ellipsis;
  overflow: hidden;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media only screen and (max-width: 768px) {
  .modal-container {
    width:90vw;
  }
}

</style>